export default __webpack_public_path__ + "static/media/lopez.433ec4ff.jpg";